import React from 'react';
import Hero from './components/exam-code-books/Hero';
import Main from './components/exam-code-books/Main';

const CodeBooks = () => {
    return (
        <div>
            <Hero />
            <Main />
        </div>
    )
}

export default CodeBooks;